<style>

.tableDesign .el-input__inner{
  border: 0;
  text-align: center;
}
</style>
<template>
  <BasicLayout>
    <template #wrapper>
      <Reward ref="RewardRef" :single="true" />
      <el-tabs active-name="1" tab-position="left" style="background-color: #ffffff;height: 800px" @tab-click="handleTabClick">
        <el-row :gutter="10" style="margin: 1rem 0">
          <CommonExcel ref="CommonExcelRef2" :import-p="'config:userLabel:import'" :export-p="'config:userLabel:export'" :import-method="importCfg" :export-method="exportCfg" />
          <clear-cache-apply />
        </el-row>
        <el-tab-pane v-for="(item,type) in typeArr" :key="type" :name="type" :label="item">
          <el-card class="box-card">
            <el-table class="tableDesign" size="mini" :data="list[type]" border style="width: 50%" height="600">
              <el-table-column label="序号" align="center" width="100">
                <template v-slot:default="{row,$index}">
                  <span style="display:block;" :title="row.id">{{ $index + 1 }}</span>
                </template>
              </el-table-column>
              <el-table-column label="名称" align="center">
                <template v-slot:default="{row}">
                  <el-input v-model="row.name" style="width: 250px;" placeholder="名称" />
                </template>
              </el-table-column>
              <el-table-column label="操作" align="center">
                <template v-slot:default="{row,$index}">
                  <el-button type="primary" size="mini" @click="openDialog(row.config)">查看</el-button>
                  <el-button type="danger" size="mini" @click="handleDel($index,row.id)">删除</el-button>
                  <el-button type="success" size="mini" @click="handleCopy(row)">拷贝</el-button>
                </template>
              </el-table-column>
            </el-table>
            <div style="float:left;margin-top: 1rem">
              <el-button type="primary" size="mini" @click="handleAdd(type,'新增配置',[])">新增</el-button>
              <el-button v-prevent-re-click type="primary" size="mini" style="margin:10px 10px" @click="handleSaveConfig()">保存</el-button>
            </div>
          </el-card>
        </el-tab-pane>
      </el-tabs>
      <el-dialog :show-close="false" :before-close="handleClose" title="提示" :visible.sync="dialog" width="75%">
        <el-table :key="tableKey" size="mini" :data="diaLogList" border fit highlight-current-row style="width: 100%;" height="500">
          <template v-if="type==1">
            <el-table-column prop="stage" label="阶段">
              <template v-slot:default="scope">
                <el-input v-model.number="scope.row.stage" placeholder="stage" />
              </template>
            </el-table-column>
            <el-table-column prop="stepnum" label="步骤进度">
              <template v-slot:default="scope">
                <el-input v-model.number="scope.row.stepnum" placeholder="stepnum" />
              </template>
            </el-table-column>
            <el-table-column prop="奖励" label="奖励">
              <template v-slot:default="scope">
                <Reward :value="scope.row.prize" />
              </template>
            </el-table-column>
          </template>
          <template v-if="type==2">
            <el-table-column prop="stage" label="阶段">
              <template v-slot:default="scope">
                <el-input v-model.number="scope.row.stage" readonly placeholder="stage" />
              </template>
            </el-table-column>
            <el-table-column prop="stepnum" label="步骤进度">
              <template v-slot:default="scope">
                <el-input v-model.number="scope.row.stepNum" placeholder="stepNum" />
              </template>
            </el-table-column>
            <el-table-column prop="name" label="名称(多语言)">
              <template v-slot:default="scope">
                <el-input v-model="scope.row.name" placeholder="名称(多语言)" />
              </template>
            </el-table-column>
            <el-table-column prop="gMax" label="可购买">
              <template v-slot:default="scope">
                <el-input v-model="scope.row.gMax" placeholder="可购买" />
              </template>
            </el-table-column>
            <el-table-column prop="prize" label="价格" align="center">
              <Price />
            </el-table-column>
            <el-table-column prop="prize" label="奖励">
              <template v-slot:default="scope">
                <Reward :value="scope.row.prize" />
              </template>
            </el-table-column>
          </template>
          <el-table-column label="操作" align="center" width="100">
            <template v-slot:default="{row,$index}">
              <el-button style="margin-left: .5rem;display:block;" size="mini" type="danger" @click="deleteRewardDialogList($index)">删除</el-button>
            </template>
          </el-table-column>
        </el-table>
        <span slot="footer" class="dialog-footer" style="margin-right: 10px">
          <el-button size="small" type="primary" @click="addRewardDialogList">新增</el-button>
        </span>
        <span slot="footer" class="dialog-footer"><el-button size="small" @click="dialog = false">关 闭</el-button></span>
      </el-dialog>
    </template>
  </BasicLayout>
</template>

<script>

import CommonExcel from '@/components/CommonExcel'
import Reward from '@/components/Reward'
import { downloadExcelMultiSheet } from '@/utils/excel'
import { actAuxiliary, actionActAuxiliary, delActAuxiliary } from '@/api/config/activity-auxiliary-cfg'
import Price from '@/components/Price/index.vue'
import ClearCacheApply from '@/components/clear_cache_apply/index.vue'
import { handleImportPrize } from '@/utils'

export default {
  name: 'SuperCollectPack',
  components: { ClearCacheApply, Price, CommonExcel, Reward },
  props: {
    curClass: {
      type: String,
      default: 'super_collect_pack'
    }
  },
  data() {
    return {
      tableKey: 0,
      limitType: [2],
      loading: false,
      dialog: false,
      diaLogList: [],
      list: [],
      type: 1,
      typeArr: { 1: '进度配置', 2: '奖励配置' },
      shopSku: []
    }
  },
  created() {
    this.init()
  },
  methods: {
    init() {
      this.getList()
    },
    handleClose(done) {
      this.$confirm('确认关闭？')
        .then(_ => {
          done()
        })
        .catch(_ => {})
    },
    openDialog(config) {
      this.tableKey++
      this.diaLogList = config
      this.dialog = true
    },
    handleTabClick(val) {
      this.type = Number(val.name)
      this.diaLogList = []
    },
    getList() {
      this.loading = true
      actAuxiliary({ class: this.curClass, select: 0 }).then(response => {
        this.list = response.data
        for (const key in this.typeArr) {
          if (this.list[key] === undefined || this.list[key] == null) {
            this.list[key] = []
          }
        }
        this.loading = false
      })
    },
    handleDel(index, id) {
      this.$confirm('确认要删除吗?', '警告', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        if (id !== 0) {
          delActAuxiliary({ idList: [id] })
        }
        this.list[this.type].splice(index, 1)
      })
    },
    handleCopy(row) {
      const _row = Object.assign({}, row)
      _row.id = 0
      this.list[this.type].push(_row)
    },
    handleAdd(type, name, config) {
      this.list[type].push({ id: 0, name: name, class: this.curClass, type: type, config: config })
    },
    importCfg(updateInfo) {
      const excelData = updateInfo.data
      for (let i = 0; i < excelData.length; i++) {
        const sheet = excelData[i].sheetName
        let editFlag = false
        for (let j = 0; j < this.list[this.type].length; j++) {
          if (this.list[this.type][j].name === sheet) {
            this.list[this.type][j].config = handleImportPrize(excelData[i].sheetData)
            editFlag = true
          }
        }
        if (!editFlag) {
          this.handleAdd(this.type, sheet, handleImportPrize(excelData[i].sheetData))
        }
      }
    },
    handleSaveConfig(type) {
      actionActAuxiliary({ class: this.curClass, list: this.list }).then(response => {
        this.msgSuccess('保存成功', () => {
          this.getList()
        }, 1000)
      })
    },
    exportCfg() {
      const nameArr = []
      const dataArr = []
      for (let i = 0; i < this.list[this.type].length; i++) {
        nameArr.push(this.list[this.type][i].name)
        dataArr.push(this.list[this.type][i].config)
      }
      this.onExport(this.type, nameArr, dataArr)
      return Promise.reject()
    },
    onExport(type, name, dataArr) {
      let fileName = ''
      const hearer = []
      const excelData = []
      let field = {}
      switch (this.type) {
        case 1:
          fileName = '进度配置'
          field = { stage: '阶段', stepnum: '步骤进度', prize: { name: '奖励', sub: { propsId: '道具', num: '数量', rtype: '取值类型', skin: '皮肤' }}}
          break

        case 2:
          fileName = '奖励配置'
          field = { stage: '阶段', stepNum: '步骤进度', name: '多语言名称', gMax: '可购买', mtype: '类型', sku: '库存', bet: '倍数', price: '价格', prize: { name: '奖励', sub: { propsId: '道具', num: '数量', rtype: '取值类型', skin: '皮肤' }}}
          break
      }
      // fileName = this.typeArr[type]
      for (let i = 0; i < dataArr.length; i++) {
        const tAk = this.$refs.CommonExcelRef2.makeExcelData(dataArr[i], field)
        hearer.push(tAk[0])
        excelData.push(tAk[1])
      }
      downloadExcelMultiSheet(this.$route.meta.title + '-' + fileName, name, hearer, excelData)
    },
    addRewardDialogList(index) {
      const len = this.diaLogList.length
      switch (this.type) {
        case 1:
          this.diaLogList.push({ stage: len + 1, stepnum: 1, prize: [] })
          break

        case 2:
          this.diaLogList.push({ stage: len + 1, stepNum: 1, name: '', prize: [] })
          break
      }
    },
    deleteRewardDialogList(index) {
      this.diaLogList.splice(index, 1)
    }
  }
}
</script>

